export const faqData = [
  {
    question: "Что такое вейджер и как он влияет на отыгрыш бонуса?",
    answer: "Вейджер (wager) — это коэффициент отыгрыша бонуса. Например, при вейджере x40 и бонусе 10 000 ₽ вам нужно сделать ставок на общую сумму 400 000 ₽. Чем ниже вейджер, тем легче отыграть бонус и вывести выигрыш."
  },
  {
    question: "Можно ли вывести бонусные деньги сразу после получения?",
    answer: "Нет, бонусные средства необходимо отыграть согласно условиям казино. Только после выполнения требований по вейджеру вы сможете вывести выигрыш. Попытка вывода до отыгрыша приведет к аннулированию бонуса."
  },
  {
    question: "Какие игры лучше всего подходят для отыгрыша бонуса?",
    answer: "Слоты обычно засчитываются на 100% в отыгрыш. Настольные игры (рулетка, блэкджек) часто имеют вклад 10-20% или вообще исключены. Всегда проверяйте условия конкретного казино перед началом отыгрыша."
  },
  {
    question: "Что такое бездепозитный бонус и как его получить?",
    answer: "Бездепозитный бонус — это фриспины или деньги, которые казино дает за регистрацию без необходимости пополнения счета. Обычно выдается автоматически после верификации email или телефона. Сумма небольшая (500-1000 ₽), но позволяет протестировать казино бесплатно."
  },
  {
    question: "Чем отличается кешбэк от приветственного бонуса?",
    answer: "Приветственный бонус выдается один раз при первом депозите. Кешбэк — это возврат части проигранных средств (обычно 5-20%), который начисляется регулярно (еженедельно или ежемесячно). Кешбэк часто имеет более мягкие условия отыгрыша или вообще не требует вейджера."
  },
  {
    question: "Есть ли ограничения на максимальную ставку при отыгрыше бонуса?",
    answer: "Да, большинство казино устанавливают лимит на максимальную ставку (обычно 50-100 ₽) при игре с активным бонусом. Превышение этого лимита может привести к аннулированию бонуса и всех выигрышей."
  },
  {
    question: "Можно ли использовать несколько бонусов одновременно?",
    answer: "Нет, одновременно может быть активен только один бонус. Перед активацией нового бонуса необходимо полностью отыграть или отменить предыдущий. Некоторые казино позволяют накапливать фриспины, но денежные бонусы всегда используются по очереди."
  },
  {
    question: "Что делать, если бонус не зачислился после депозита?",
    answer: "Сначала проверьте, активировали ли вы бонус перед депозитом (часто требуется ввести промокод или поставить галочку). Если все сделано правильно, обратитесь в службу поддержки казино с указанием суммы депозита и времени транзакции. Обычно проблема решается в течение нескольких минут."
  }
];